@import "../../sass/base/text-styles";

:host {
  display: flex;
  flex-wrap: nowrap;

  > img {
    vertical-align: middle;
  }
}

img {
  margin-right: 8px;
}

:host([class^="ts-small"]) {
  display: inline-block;

  > img {
    position: relative;
    top: -2px;
    height: 0.875rem;
    margin-right: 2px;
  }
}
